module.exports = __webpack_public_path__ + "img/ico-user-active.30c98e78.svg";